import { isNumber, isString, isObject } from 'typechecker'

type Birthday = string
type Time = string
type Email = string
type FbId = string
type Id = number
type Identity = string
type Mobile = string
type Name = string
type booleanNum = 0 | 1

/** 客戶 */
export default class UserFirebase {
  /** 生日 */
  birthday?: Birthday

  /** 是否使用優惠卷 */
  coupon?: booleanNum
  /** 建立時間 */
  created?: Time
  // eslint-disable-next-line camelcase
  created_at?: Time

  /** 電子郵件 */
  email?: Email
  /** facebook ID */

  // eslint-disable-next-line camelcase
  fb_id?: FbId
  /** gogoout ID */

  id?: Id
  /** 身分證字號 */
  identity?: Identity
  /** 帳號是否被 ban */
  inuse?: booleanNum
  /** email 驗證通過 */

  // eslint-disable-next-line camelcase
  mail_confirmed?: booleanNum
  /** 手機號碼 */
  mobile?: Mobile
  /** 手機號碼是否已驗證 */
  // eslint-disable-next-line camelcase
  mobile_confirmed?: booleanNum

  /** 姓名 */
  name?: Name

  /** 是否接受推播訊息 */
  sendNews?: booleanNum

  /** 更新個人資料時間 */
  updated?: Time
  // eslint-disable-next-line camelcase
  updated_at?: Time

  /** 歷史遺跡 just put it inside  */
  // eslint-disable-next-line camelcase
  website_id?: booleanNum

  constructor (user: {
    birthday?: string

    coupon?: booleanNum
    created?: Time
    // eslint-disable-next-line camelcase
    created_at?: Time

    email?: Email

    // eslint-disable-next-line camelcase
    fb_id?: FbId

    id?: Id
    identity?: Identity
    inuse?: booleanNum

    // eslint-disable-next-line camelcase
    mail_confirmed?: booleanNum
    mobile?: Mobile
    // eslint-disable-next-line camelcase
    mobile_confirmed?: booleanNum

    name?: Name

    sendNews?: booleanNum

    updated?: Time
    // eslint-disable-next-line camelcase
    updated_at?: Time

    // eslint-disable-next-line camelcase
    website_id?: booleanNum
  }) {
    if (!isObject(user)) throw new TypeError('`user` must be an object!')

    if (isString(user.birthday)) this.birthday = user.birthday

    if (isNumber(user.coupon)) this.coupon = user.coupon
    if (isString(user.created)) this.created = user.created
    if (isString(user.created_at)) this.created_at = user.created_at

    if (isString(user.email)) this.email = user.email

    if (isString(user.fb_id)) this.fb_id = user.fb_id

    if (isNumber(user.id)) this.id = user.id
    if (isString(user.identity)) this.identity = user.identity
    if (isNumber(user.inuse)) this.inuse = user.inuse

    if (isNumber(user.mail_confirmed)) this.mail_confirmed = user.mail_confirmed
    if (isString(user.mobile)) this.mobile = user.mobile
    if (isNumber(user.mobile_confirmed)) this.mobile_confirmed = user.mobile_confirmed

    if (isString(user.name)) this.name = user.name

    if (isNumber(user.sendNews)) this.sendNews = user.sendNews

    if (isString(user.updated)) this.updated = user.updated
    if (isString(user.updated_at)) this.updated_at = user.updated_at

    if (isNumber(user.website_id)) this.website_id = user.website_id
  }
}
